import { render, staticRenderFns } from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=template&id=718c67ae&scoped=true"
import script from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderLabourHeadingsComponent.vue?vue&type=style&index=0&id=718c67ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c67ae",
  null
  
)

export default component.exports